/**
 * Берёт UUID выбранных доп. услуг и оставляет только те,
 * что есть в списке услуг текущего автосервиса.
 */
export const toAdditionalServiceUuids = (
  selected: Array<{ value?: string | number | null }>,
  allowedServices: Array<{ uuid: string }>,
): string[] | undefined => {
  const allowed = new Set(allowedServices.map((service) => service.uuid));
  const uuids = selected
    .map((item) => (item.value == null ? '' : String(item.value)))
    .filter((uuid) => allowed.has(uuid));

  return uuids.length > 0 ? uuids : undefined;
};
